<div *ngIf="loading">
  Loading...
</div>
<div class="content">

  <div class="course-content-container" [ngStyle]="{'max-width': isYEUser() ? 'none' : 'calc(100% - 240px)'}">
    <div class="plate plate-dark_blue swoosh swoosh-cfi-home" *ngIf="authContextService.isValidCFIUser()">
      <div class="row plate-header w-100 no-gutters flex-container justify-content-start align-items-center">
        <h2 style="color: white !important; text-transform: none;">Welcome
          Back {{ authContextService.user?.first_name }}!
        </h2>
        <app-info-tooltip tooltip="Complimentary access to our most popular courses"></app-info-tooltip>
      </div>
      <div class="row">
        <div class="col-12">
          <p>Enjoy complimentary access to Sporty’s Learn to Fly, Instrument Rating and Commercial Pilot training
            courses</p>
        </div>
      </div>
      <div class="row col-12 px-2">
        <a routerLink="/cfi/home" class="btn btn-round btn-shadow btn-primary px-3 py-2 mt-4 ml-2">Go to CFI Portal</a>
      </div>
    </div>
    <div class="latest-course" *ngIf="!loading">
      <div class="area">
        <h2>Latest Activity</h2>
      </div>
      <div class="card">
        <div class="row no-gutters">
          <div class="image-wrapper">
            <div class="image"
                 [ngStyle]="{'background-image': 'url('+ latestCourse?.thumbnailUrl + ')'}">
            </div>
          </div>
          <div class="card-body">
            <div class="card-title">
              <h2>{{ latestCourse?.name }}&nbsp;</h2>
            </div>
            <div class="card-text">
              <div *ngIf="!latestCourse || latestCourse?.displayPercentComplete === false"
                   style="height:40px; width:100%;"></div>
              <div class="course-progress-container"
                   *ngIf="latestCourse && latestCourse?.displayPercentComplete !== false">
                <div class="course-progress-bar_background"
                     [ngClass]="{'course-progress-bar_position_right': latestCourse?.percentageComplete < 50.0}">
                  <div *ngIf="latestCourse" class="course-progress-bar_background_number">
                    {{ latestCourse?.percentageComplete }}%
                  </div>
                </div>
                <div class="course-progress-bar" *ngIf="latestCourse" [ngStyle]="{width:progressWidth(latestCourse)}"
                     [ngClass]="{'course-progress-bar_position_left': latestCourse?.percentageComplete > 50.0}">
                  <div class="course-progress-bar_background_number">
                    {{ latestCourse?.percentageComplete }}%
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="!isLatestCourseGroup" class="card-text card-text_continue">
              <a (click)="openCourse(latestCourse, latestCourse?.progress?.userCourse)"
                 class="btn btn-primary btn-round btn-plane" [attr.disabled]="!latestCourse?'':null"
                 [ngClass]="{'disabled':!latestCourse}">Continue</a>
            </div>
            <div *ngIf="isLatestCourseGroup" class="card-text card-text_continue">
              <a (click)="openModal(latestCourse)"
                 class="btn btn-primary btn-round btn-plane"
                 [ngClass]="{'disabled':!latestCourse}">Continue</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="course-content-header" *ngIf="!loading && ownedCourseGroups.length > 0">
      <div class="course-content-header_title area">
        <h2>My Courses</h2>
      </div>
      @if (!isYEUser()) {
        <div class="course-content-header_controls area">
          <div class="btn-group" dropdown>
            <button id="button-basic" dropdownToggle type="button" class="btn btn-white btn-round dropdown-toggle"
                    aria-controls="dropdown-basic">
              Filter <span class="caret"></span>
            </button>
            <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right" role="menu"
                aria-labelledby="button-basic">
              <li role="menuitem">
                <a class="dropdown-item" [ngClass]="{'active': this.showing === 'ALL'}" (click)="showAll($event)"
                   href="#">All</a>
              </li>
              <li role="menuitem">
                <a class="dropdown-item" [ngClass]="{'active': this.showing === 'FAVORITES'}"
                   (click)="showFavorites($event)" href="#">Favorites</a>
              </li>
              <li role="menuitem" *ngFor="let tag of tags">
                <a class="dropdown-item" [ngClass]="{'active': this.showing === tag}" (click)="show($event, tag)"
                   href="#">{{ tag }}</a>
              </li>
            </ul>
          </div>
        </div>
      }
    </div>
    <div class="course-content-header" *ngIf="!loading && !ownedCourseGroups?.length && !relatedCourseGroups?.length">
      <div class="course-content-header_title area">
        <h2>Course Demos</h2>
      </div>
    </div>

    <!--
    <div class="navigation-container navigation-container-tablet">
      <ul class="nav flex-md-row flex-lg-column">
        <li class="nav-item">
          <a class="nav-link" (click)="showAll($event)">All</a>
        </li>
        <li class="nav-item" *ngFor="let tag of tags">
          <a class="nav-link" (click)="show($event, tag)">{{tag}}</a>
        </li>
      </ul>
    </div>
    -->
    <!--
    <div class="navigation-container">
      <div class="btn-group" dropdown>
        <button id="button-basic" dropdownToggle type="button" class="btn btn-white dropdown-toggle"
                aria-controls="dropdown-basic">
          Filter <span class="caret"></span>
        </button>
        <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right"
            role="menu" aria-labelledby="button-basic">
          <li role="menuitem">
            <a class="dropdown-item" (click)="showAll($event)" href="#">All</a>
          </li>
          <li role="menuitem" *ngFor="let tag of tags">
            <a class="dropdown-item" (click)="show($event, tag)" href="#">{{tag}}</a>
          </li>
        </ul>
      </div>
    </div>
    -->
    <div class="courses-container card-container" *ngIf="ownedCourseGroups">
      <ng-template ngFor let-courseGroup
                   [ngForOf]="( ownedCourseGroups | tagFilter:selectedTags:showAllCourses | favoriteFilter:showOnlyFavorites)">
        <ng-template [ngIf]="courseGroup.courses.length > 1">
          <app-course-group-card class="course-wrapper" [courseGroup]="courseGroup" [purchased]="true">
          </app-course-group-card>
        </ng-template>
        <ng-template ngFor let-course [ngForOf]="courseGroup.courses">
          <app-course-card class="course-wrapper" *ngIf="courseGroup.courses.length === 1" [course]="course"
                           [purchased]="true"></app-course-card>
        </ng-template>
      </ng-template>
      <ng-template ngFor let-courseGroup
                   [ngForOf]="( defaultCourseGroups | tagFilter:selectedTags:showAllCourses | favoriteFilter:showOnlyFavorites)">
        <ng-template [ngIf]="courseGroup.courses.length > 1">
          <app-course-group-card class="course-wrapper" [courseGroup]="courseGroup" [purchased]="courseGroup.isOwned">
          </app-course-group-card>
        </ng-template>
        <ng-template ngFor let-course [ngForOf]="courseGroup.courses">
          <app-course-card class="course-wrapper" *ngIf="courseGroup.courses.length === 1" [course]="course"
                           [purchased]="course.courseGroup.isOwned"></app-course-card>
        </ng-template>
      </ng-template>
      <ng-template ngFor let-courseGroup
                   [ngForOf]="( preownedCourseGroups | tagFilter:selectedTags:showAllCourses | favoriteFilter:showOnlyFavorites)">
        <ng-template ngFor let-course [ngForOf]="courseGroup.courses">
          <app-course-card class="course-wrapper" *ngIf="courseGroup.courses.length === 1" [course]="course"
                           purchased="true"></app-course-card>
        </ng-template>
      </ng-template>
    </div>

    <div class="course-content-header" *ngIf="!loading && relatedCourseGroups.length > 0">
      <div class="course-content-header_title">
        <h2>Related Courses</h2>
      </div>
    </div>
    <div class="courses-container card-container">
      <ng-template ngFor let-courseGroup [ngForOf]="( relatedCourseGroups)">
        <ng-template [ngIf]="courseGroup.courses.length > 1">
          <app-course-group-card class="course-wrapper" [courseGroup]="courseGroup" [purchased]="false">
          </app-course-group-card>
        </ng-template>
        <ng-template ngFor let-course [ngForOf]="courseGroup.courses">
          <app-course-card class="course-wrapper" *ngIf="courseGroup.courses.length === 1" [course]="course"
                           [purchased]="false"></app-course-card>
        </ng-template>
      </ng-template>
    </div>
    <div *ngIf="!loading && ownedCourseGroups.length === 0" class="no-courses-content-container">
      @if (!isYEUser()) {
        <div class="learn-content-container">
          <p>Sporty's offers a wide variety of aviation training courses, including pilot training, avionics eLearning,
            aircraft transition and flight currency.</p>
          <a routerLink="/home/learn" class="btn btn-round btn-lg btn-shadow btn-primary btn-width-fixed-240">Discover
            Sporty's Courses</a>
        </div>
      }
      <div *ngIf="!authContextService.user">
        <p>Already learning?</p>
        <a routerLink="/login" class="btn btn-round btn-lg btn-shadow btn-primary bg-primary btn-width-fixed-240">Log in
          to see your courses.</a>
      </div>
    </div>

    <!--
        <div class="course-separator">
          Not Yet Purchased:
          <hr>
        </div>
        <div class="courses-container">
          <div *ngFor="let courseGroup of unownedCourseGroups"
               class="course-group"
               [ngClass]="{'multiple-courses':courseGroup.courses.length > 1}">
            <div class="course-group_box">
              <div
                class="multiple-course_header"
                *ngIf="courseGroup.courses.length > 1">
                <div class="course-group_label" *ngIf="courseGroup.name">
                  {{courseGroup.name}}
                </div>
                <div class="course-group_links">
                  <ul>
                    <li>
                      Foreflight
                    </li>
                    <li>
                      FAA Library
                    </li>
                    <li>
                      CloudAhoy
                    </li>
                  </ul>
                </div>
              </div>
              <div [ngClass]="{'multiple-course_body' : courseGroup.courses.length> 1}">
                <div app-course-card *ngFor="let course of courseGroup.courses"
                     [course]="course"
                     [purchased]="false"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    -->
  </div>
  @if (!isYEUser()) {
    <div class="right-container" *ngIf="!loading">
      <h2>Free Resources</h2>
      <div app-marketing-card></div>

      <div app-feed-card [name]="'STUDENT_PILOT_NEWS'"
           [background]="'https://dl.videos.sportys.com/onlinecourse/images/SPN_blog.jpg'"></div>
      <div app-feed-card [name]="'IPAD_PILOT_NEWS'"
           [background]="'https://dl.videos.sportys.com/onlinecourse/images/IPN_blog.jpg'"></div>

    </div>
  }
  @if (!isYEUser() && ownedCourseGroups.length > 0) {
    <div class="learn-content-container">
      <p>Sporty's offers a wide variety of aviation training courses, including pilot training, avionics eLearning,
        aircraft transition and flight currency.</p>
      <a routerLink="/home/learn" class="btn btn-round btn-primary bg-primary btn-width-fixed-240">Discover Sporty's
        Courses</a>
    </div>
  }
</div>
